import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { AuthService, isAdmin, isDriver, isFiveFTourDispatcher, LoHiUserInfo } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const isHoliday2021 = route.url.length && route.url[0].path === 'h2021';
    const allowDriver = !!route.data.allowDriver; // Should default to false on all of our routes, since we never let drivers in, this is good
    const allowFiveFTourDispatcher = !!route.data.allowFiveFTourDispatcher;
    return combineLatest([
      this.authService.userInfo$.pipe(
        filter((u) => !!u?.id),
        startWith(null as LoHiUserInfo),
      ),
      this.authService.isLoggedIn$.pipe(
        filter((b) => b != null),
        startWith(null as boolean),
      ),
    ]).pipe(
      filter(([userInfo, isLoggedIn]) => {
        return userInfo !== null || isLoggedIn !== null;
      }),
      map(([userInfo, isLoggedIn]) => {
        if (isLoggedIn === false) {
          if (isHoliday2021) {
            return this.router.parseUrl(`/auth/b2021?redirectTo=${state.url}`);
          }
          return this.router.parseUrl(`/auth/login?redirectTo=${state.url}`);
        }
        if (isAdmin(userInfo)) {
          return true;
        }
        if (allowDriver && isDriver(userInfo)) {
          return true;
        }
        if (allowFiveFTourDispatcher && isFiveFTourDispatcher(userInfo)) {
          return true;
        }
        if (isHoliday2021) {
          return this.router.parseUrl(`/auth/b2021?redirectTo=${state.url}`);
        }
        return this.router.parseUrl(`/auth/login?redirectTo=${state.url}`);
      }),
    );
  }
}
